(async function initAlerts() {
    const alertsContainer = document.getElementById("alerts-container");
    if (!alertsContainer) return;

    const showAlerts = document.querySelectorAll(".showalerts");

    // Helper to toggle visibility across all elements
    const toggleShowAlerts = (displayStyle) => {
        showAlerts.forEach(el => el.style.display = displayStyle);
    };

    // Helper function to lazy-load docCookies when needed
    let docCookiesModule = null;
    const getDocCookies = async () => {
        if (!docCookiesModule) {
            const module = await import('./doccookies.js');
            docCookiesModule = module.default || module;
        }
        return docCookiesModule;
    };

    // Initial state check
    if (alertsContainer.offsetParent === null) {
        toggleShowAlerts("block");
    } else {
        toggleShowAlerts("none");
    }

    // Collapse event listener
    alertsContainer.addEventListener("hide.bs.collapse", async () => {
        console.log("hide.bs.collapse - setting cookie");

        const hash = alertsContainer.dataset.hash || alertsContainer.getAttribute("data-hash");
        const expiryDate = new Date();
        expiryDate.setFullYear(expiryDate.getFullYear() + 5);
        expiryDate.setMonth(1);
        expiryDate.setDate(1);

        try {
            const docCookies = await getDocCookies();
            docCookies.setItem("closealert", hash, expiryDate, "/");
        } catch (error) {
            console.error("Failed to load docCookies module:", error);
        }

        toggleShowAlerts("block");
    });

    // Show alert click event listeners
    showAlerts.forEach(element => {
        element.addEventListener("click", async () => {
            alertsContainer.classList.add("show");

            const alertToggler = alertsContainer.querySelector(".alert-close");
            if (alertToggler) {
                alertToggler.setAttribute("aria-expanded", "true");
                alertToggler.classList.remove("collapsed");
            }

            try {
                const docCookies = await getDocCookies();
                docCookies.removeItem("closealert", "/");
            } catch (error) {
                console.error("Failed to load docCookies module:", error);
            }

            toggleShowAlerts("none");
            window.scrollTo({ top: 0, behavior: 'smooth' });
        });
    });
})();